export enum ProjectRuntimes {
    APPLICATION = 'application',
    JEST = 'jest',
}
